/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Indexnow_Step_KeyInputs */

const en_admin_indexnow_step_key = /** @type {(inputs: Admin_Indexnow_Step_KeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. API key`)
};

/**
* | output |
* | --- |
* | "1. API key" |
*
* @param {Admin_Indexnow_Step_KeyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_indexnow_step_key = /** @type {((inputs?: Admin_Indexnow_Step_KeyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Indexnow_Step_KeyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_indexnow_step_key(inputs)
});
export { admin_indexnow_step_key as "admin.indexnow.step_key" }